import axios from 'axios';

export const getActionRequiredWatch = async (options = {}) => {
    const params = {};
    if (options.programName) params.programName = options.programName;
    if (
        options.minDaysRemaining !== undefined &&
        options.minDaysRemaining !== null &&
        String(options.minDaysRemaining).trim() !== ''
    ) {
        params.minDaysRemaining = options.minDaysRemaining;
    }
    const { data } = await axios.get('/api/action-required-watch', {
        params: Object.keys(params).length ? params : undefined,
    });
    return data;
};

export const getActionRequiredWatchHistory = async (options = {}) => {
    const params = {};
    if (options.programName) params.programName = options.programName;
    if (options.days !== undefined && options.days !== null && String(options.days).trim() !== '') {
        params.days = options.days;
    }
    const { data } = await axios.get('/api/action-required-watch/history', {
        params: Object.keys(params).length ? params : undefined,
    });
    return data;
};
